export default Object.freeze({
  EXACT_MATCH: "EXACT_MATCH",
  SIMILARITY: "SIMILARITY",
  LOCATION: "LOCATION",
  PROXIMITY: "PROXIMITY",
});
